import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';
export var PartnerContents = function (_a) {
  var partnerProvidedDetails = _a.partnerProvidedDetails;
  if (!partnerProvidedDetails) {
    return null;
  }
  return React.createElement(UitkSpacing, {
    margin: {
      inline: 'three'
    }
  }, React.createElement("div", null, partnerProvidedDetails.map(function (value, index) {
    return React.createElement(UitkSpacing, {
      margin: {
        blockend: 'three'
      },
      key: "partner-provider-details-".concat(index)
    }, React.createElement("div", null, React.createElement(UitkHeading, {
      tag: "h2",
      size: 4
    }, value.heading), React.createElement(UitkText, {
      size: 300
    }, value.body)));
  })));
};